import * as React from "react";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
import InputBase from "@mui/material/InputBase";
import { styled, alpha, useTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";
import Avatar from "@mui/material/Avatar";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  canTriggerSearchSubmit,
  shouldAutoClearSearch,
} from "../utils/searchFieldUtils";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../redux/authSlice";
import { Badge } from "@mui/material";
import { useIndexPageData } from "../contextapi/Indexpagedata";
import { toast } from "react-toastify";
import CookiePreferences from "./CookiePreferences";
import { TbLogout } from "react-icons/tb";
import useMediaQuery from "@mui/material/useMediaQuery";
import SiteMobileNavDrawer from "../components/nav/SiteMobileNavDrawer";
import { parseReferralId, storeReferralId } from "../utils/referral";
import { useAuthModal } from "../contextapi/AuthModalContext";

const logoStyle = {
  width: "139px",
  height: "auto",
  cursor: "pointer",
  marginRight: "10px",
};
const simpleLogoStyle = {
  width: "30px",
  height: "auto",
  cursor: "pointer",
  marginRight: "10px",
  paddingRight: "1px",
};

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  flexGrow: 1,
  minWidth: 0,
  display: "flex",
  alignItems: "center",
  backgroundColor: "#F5F7F8",
  marginLeft: 0,
  border: "1px solid rgba(0,0,0,0.05)",
  borderRadius: "8px",
  width: "100%",
  height: "40px",
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  position: "absolute",
  top: 0,
  right: 0,
  height: "40px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  [theme.breakpoints.up("sm")]: {
    width: "40px",
  },
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "#AAACAC",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 1),
    paddingRight: "calc(25px + 12px)",
    fontSize: "14px",
    lineHeight: 1.4,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      paddingRight: `calc(38px + ${theme.spacing(1)})`,
      fontSize: "15px",
    },
  },
}));

const Navbar = () => {
  const Navigate = useNavigate();
  const location = useLocation();
  const [searchmockup, setsearchmockup] = useState("");
  const {
    profiledata,
    fetchDataprofile,
    cartItems,
    fetchcart,
    setprofiledata,
  } = useIndexPageData();
  const { isLoggedIn, userType } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [showCookieSettings, setShowCookieSettings] = React.useState(false);
  const { openAuthModal } = useAuthModal();
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));
  const isTabletScreen = useMediaQuery(theme.breakpoints.between("sm", "lg"));

  const handleinitModal = () => {
    openAuthModal("login");
  };

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const scrollToSection = (sectionId) => {
    const sectionElement = document.getElementById(sectionId);
    const offset = 128;
    if (sectionElement) {
      const targetScroll = sectionElement.offsetTop - offset;
      sectionElement.scrollIntoView({ behavior: "smooth" });
      window.scrollTo({
        top: targetScroll,
        behavior: "smooth",
      });
      setOpen(false);
    }
  };
  const length = cartItems.length;
  const navigate = useNavigate();

  const navigateToSearch = (query) => {
    const params = new URLSearchParams(location.search);
    if (query) {
      params.set("overAllSearch", query);
    } else {
      params.delete("overAllSearch");
    }
    const qs = params.toString();
    navigate(qs ? `/Searchpage?${qs}` : "/Searchpage");
  };

  const handlesearch = () => {
    const trimmed = searchmockup.trim();
    if (!canTriggerSearchSubmit(trimmed)) return;
    navigateToSearch(trimmed);
  };

  const handleSearchInputChange = (e) => {
    const newValue = e.target.value;
    setsearchmockup(newValue);
    const params = new URLSearchParams(location.search);
    if (
      shouldAutoClearSearch(newValue, params.get("overAllSearch") || "") &&
      location.pathname === "/Searchpage"
    ) {
      navigateToSearch("");
    }
  };

  useEffect(() => {
    if (location.pathname === "/Searchpage") {
      const params = new URLSearchParams(location.search);
      setsearchmockup(params.get("overAllSearch") || "");
    }
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (location.pathname !== "/") return;

    const params = new URLSearchParams(location.search);
    const referralId = parseReferralId(params.get("referral_id"));
    if (!referralId) return;

    storeReferralId(referralId);
    if (!isLoggedIn) {
      openAuthModal("register");
    }

    params.delete("referral_id");
    const qs = params.toString();
    navigate(
      { pathname: "/", search: qs ? `?${qs}` : "" },
      { replace: true }
    );
  }, [isLoggedIn, location.pathname, location.search, navigate, openAuthModal]);

  return (
    <div>
      <AppBar
        position="fixed"
        sx={{
          boxShadow: 0,

          bgcolor: "transparent",
          backgroundImage: "none",
          boxShadow: "0px 3px 6px 0px rgba(0,0,0,0.05)",
          borderBottom: "1px solid rgba(0,0,0,0.05)",
          backgroundColor: "#fff",
          zIndex: "1200",
        }}
      >
        <Container maxWidth="lg" className="px-1 lg-px-3">
          <Toolbar
            variant="regular"
            sx={(theme) => ({
              display: "flex",
              gap: { md: 1.5 },
              alignItems: "center",
              justifyContent: "space-between",
              flexShrink: 0,
              bgcolor: "white",
              backdropFilter: "blur(24px)",
              paddingLeft: { md: 1, lg: 1.5 },
              paddingRight: { xs: 0, md: 1, lg: 1.5 },
              py: "2px",
            })}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexShrink: 0,
                ml: "-18px",
                px: 0,
              }}
            >
              <Link to={"/"}>
                <img
                  className="d-none d-lg-block"
                  src={"../assets/images/mockee-logo.png"}
                  style={logoStyle}
                  alt="logo of sitemark"
                />

                <img
                  className="d-lg-none mx-3"
                  src={"../assets/images/justLogo.svg"}
                  style={simpleLogoStyle}
                  alt="logo of sitemark"
                />
              </Link>
              <Box sx={{ display: { xs: "none", md: "flex" } }}>
                <Link
                  to="/categories"
                  style={{ color: "#000", textDecoration: "none" }}
                >
                  <MenuItem
                    onClick={() => scrollToSection("Categories")}
                    sx={{ py: "6px", px: "16px" }}
                  >
                    <Typography variant="body2" color="text.primary">
                      Categories
                    </Typography>
                  </MenuItem>
                </Link>
                <Link
                  to="/learn"
                  style={{ color: "#000", textDecoration: "none" }}
                >
                  <MenuItem
                    onClick={() => scrollToSection("Learn")}
                    sx={{ py: "6px", px: "16px" }}
                  >
                    <Typography variant="body2" color="text.primary">
                      Learn
                    </Typography>
                  </MenuItem>
                </Link>
                {/* <Link to="/affilliate" style={{color:"#000" , textDecoration:"none"}}>
                <MenuItem
                  onClick={() => scrollToSection('Affiliate')}
                  sx={{ py: '6px', px: '16px' }}
                >
                  <Typography variant="body2" color="text.primary">
                    Affiliate
                  </Typography>
                </MenuItem>
                    </Link> */}
              </Box>
            </Box>
            <Box
              sx={{
                flex: "1 1 0",
                minWidth: 0,
                mr: { xs: 0.5, md: 2 },
                ml: { xs: 1, sm: 1.5, md: 0 },
              }}
            >
              <Search>
                <SearchIconWrapper
                  onClick={handlesearch}
                  style={{ cursor: "pointer" }}
                >
                  <SearchIcon
                    sx={{
                      backgroundColor: "#C93312",
                      color: "#fff",
                      pointerEvents: "none",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      width: { xs: "25px", sm: "38px" },
                      borderRadius: "8px",
                      fontSize: "20px",
                      padding: "5px",
                      boxSizing: "border-box",
                    }}
                  />
                </SearchIconWrapper>
                <StyledInputBase
                  value={searchmockup}
                  onChange={handleSearchInputChange}
                  placeholder={
                    isLargeScreen || isTabletScreen
                      ? "Search Mockups"
                      : "Search"
                  }
                  inputProps={{ "aria-label": "search" }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handlesearch();
                    }
                  }}
                />
              </Search>
            </Box>
            <Box
              className="btn-nav"
              sx={{
                display: { xs: "flex", md: "flex" },
                flexShrink: 0,
                marginLeft: { xs: 0.5, md: "auto" },
                gap: { xs: 1, md: 1, lg: 1.5 },
                alignItems: "center",
              }}
            >
              {/* <ToggleColorMode mode={mode} toggleColorMode={toggleColorMode} /> */}

              {isLoggedIn && (
                <Link to="/cart">
                  <IconButton
                    aria-label="cart"
                    sx={{ color: "#000000de", marginLeft: "5px" }}
                  >
                    <Badge badgeContent={length} color="error">
                      <ShoppingCartIcon
                        sx={{
                          width: { xs: "30px", md: "34px" },
                          height: { xs: "30px", md: "34px" },
                        }}
                      />
                    </Badge>
                  </IconButton>
                </Link>
              )}

              {isLoggedIn && (
                <Link
                  to={
                    userType === "S"
                      ? "/seller/dashboard"
                      : userType === "F"
                        ? "/affiliate/dashboard"
                        : "/user/dashboard"
                  }
                >
                  <Avatar
                    sx={{
                      marginLeft: "8px",
                      // padding: '3px 2px',
                      minWidth: { xs: "30px", md: "48px" },
                      minHeight: { xs: "30px", md: "48px" },
                      maxWidth: { xs: "30px" },
                      maxHeight: { xs: "30px" },
                      "&:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.04)", // replace 'desiredColor' with the color you want
                      },
                    }}
                    alt="Remy Sharp"
                    src={
                      profiledata.profile || "../assets/images/user_vector.svg"
                    }
                  />
                </Link>
              )}



{!isLoggedIn ? (
                <>
                  <Button
                    variant="contained"
                    className="login-btn d-none d-lg-block"
                    component="a"
                    href="#"
                    sx={{
                      padding: "6px 29px 7px",
                      fontSize: "15px",
                      borderRadius: "8px",
                      backgroundColor: "#C93312",
                      "&:hover": {
                        backgroundColor: "#C93312",
                        opacity: "0.9",
                      },
                      textTransform: "none",
                    }}
                    onClick={handleinitModal}
                  >
                    Log in
                  </Button>

                  <Avatar
                    onClick={handleinitModal}
                    sx={{
                      marginLeft: "8px",
                      minWidth: { xs: "30px", md: "48px" },
                      minHeight: { xs: "30px", md: "48px" },
                      "&:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.04)",
                      },
                    }}
                    alt="Remy Sharp"
                    className="d-lg-none cursor-pointer"
                    src={"../assets/images/user_vector.svg"}
                  />
                </>
              ) : (
                <>
                  <Button
                    variant="contained"
                    className="login-btn d-none d-lg-block"
                    component="a"
                    href="#"
                    sx={{
                      padding: "6px 29px 7px",
                      fontSize: "15px",
                      borderRadius: "8px",
                      backgroundColor: "#C93312",
                      "&:hover": {
                        backgroundColor: "#C93312",
                        opacity: "0.9",
                      },
                      textTransform: "none",
                    }}
                    onClick={() => {
                      dispatch(logout());
                      toast.success("Log out Successfully");
                      Navigate("/");
                      setprofiledata([]);
                    }}
                  >
                    Log out
                  </Button>
                  {/* 
                  <TbLogout
                    onClick={() => {
                      dispatch(logout());
                      toast.success("Log out Successfully");
                      Navigate("/");
                      setprofiledata([]);
                    }}
                    className="d-lg-none"
                    style={{
                      width: "25px",
                      height: "25px",
                      marginLeft: "5px",
                      color: "black",
                    }}
                  /> */}
                </>
              )}
            </Box>
            <Box sx={{ display: { sm: "", md: "none" } }}>
              <Button
                className=""
                variant="text"
                color="primary"
                aria-label="menu"
                onClick={toggleDrawer(true)}
                sx={{ minWidth: "30px", p: "4px" , marginRight:"12px" }}
              >
                <MenuIcon />
              </Button>
              <Drawer
                anchor="right"
                open={open}
                onClose={toggleDrawer(false)}
                PaperProps={{
                  sx: {
                    width: 300,
                    maxWidth: "88vw",
                    border: "none",
                    boxShadow: "0 12px 40px rgba(15, 23, 42, 0.18)",
                  },
                }}
              >
                <SiteMobileNavDrawer
                  onClose={toggleDrawer(false)}
                  isLoggedIn={isLoggedIn}
                  userType={userType}
                  profiledata={profiledata}
                  onLogout={() => {
                    dispatch(logout());
                    toast.success("Log out Successfully");
                    Navigate("/");
                    setprofiledata([]);
                  }}
                  onCookieSettings={() => setShowCookieSettings(true)}
                  onLogin={handleinitModal}
                />
              </Drawer>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <CookiePreferences
        show={showCookieSettings}
        onClose={() => setShowCookieSettings(false)}
        showBanner
      />
    </div>
  );
};

export default Navbar;
